/* eslint-disable */
import { ORDERS_CONFIRMATION, ORDERS_CONFIRMATION_COMPLETE, ORDERS_CONFIRMATION_ERROR, ORDERS_CONFIRMATION_SUCCESS } from '../Orders.types';

/**
 * Confirm a specific `order` by its `date, orderCode`
 * @param {OrderServiceOrderConfirmationDto} dto The required params to confirm an order by its `date, orderCode`
 * @returns {ActionCreator<FromPromise>} The created `Action`
 */
const ordersConfirmOrder = ({ date, orderCode, orderKey }) => ({ orderService, fromPromise }) => {
  const promise = orderService.confirmOrder({ date, orderCode, orderKey });
  return fromPromise(promise, { params: { date, orderCode, orderKey } }, [
    ORDERS_CONFIRMATION,
    ORDERS_CONFIRMATION_COMPLETE,
    ORDERS_CONFIRMATION_ERROR,
    ORDERS_CONFIRMATION_SUCCESS,
  ]);
};

export default ordersConfirmOrder;
